import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { YUPValidationsServiceCreation, trimInputHandler } from "./helper";
import {
  MandatoryStar,
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../../Utils/helper";
import {
  activeInactiveTestCreationAction,
  addServiceCreationAction,
  getTestCreationAction,
  getTestCreationByIdAction,
} from "../../../../redux/actions/TestPackageCreationAction";
import Select from "react-select";
import Modal from "react-modal";
import { GET_PREPARATION_FOR_CHECKUP } from "../../../../Utils/types";
import { getSkuSearchTagValues } from "../../TestPackages/Test/helper";

export const AddServiceCreationPopup = ({
  isAddServiceCreation,
  setIsAddServiceCreation,
  searchFilterTest,
  isRowData,
  setSearchFilterTest,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [createNewText, setCreateNewText] = useState(null);
  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const TestPackageCreationReducer = useSelector(
    (state) => state?.TestPackageCreationReducer
  );
  useEffect(() => {
    if (isAddServiceCreation?.rowData !== null) {
      isLoadingAction(true, dispatch);
      const resp = dispatch(
        getTestCreationByIdAction(
          isAddServiceCreation?.rowData?.productFacilityId
        )
      );
      resp.then((res) => {
        isLoadingAction(false, dispatch);
        setData(res?.data?.results);
      });
    }
  }, [isAddServiceCreation]);

  const handleClose = async (type) => {
    setIsAddServiceCreation({
      isOpen: false,
      rowData: null,
    });
    setSearchFilterTest({
      ...searchFilterTest,
      page: type === "modalClose" ? searchFilterTest?.page : 1,
    });
    await dispatch(
      getTestCreationAction({
        ...searchFilterTest,
        page: type === "modalClose" ? searchFilterTest?.page : 1,
      })
    );
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          {isAddServiceCreation?.rowData === null ? "Create SKU" : "Update SKU"}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => handleClose("modalClose")}
        ></button>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          const temp = {
            ...values,
            diagnosticCategoryId: isRowData?.diagnosticCategoryId,
            testId:
              isAddServiceCreation?.rowData === null
                ? 0
                : isAddServiceCreation?.rowData?.productFacilityId,
            isActiveForPPHC:
              isAddServiceCreation?.rowData === null
                ? true
                : values?.isActiveForPPHC,
            isActiveForProduct:
              isAddServiceCreation?.rowData === null
                ? true
                : values?.isActiveForProduct,
            maxAge: values?.maxAge === "" ? null : values?.maxAge,
            minAge: values?.minAge === "" ? null : values?.minAge,
            hvChargesId: values?.hvChargesId === "" ? 0 : values?.hvChargesId,
            facilityTypeId: 14,
            skUmessage_1: values?.skUmessage_1,
            skUmessage_2: values?.skUmessage_2,
            skUmessage_3: values?.skUmessage_3,
            skUmessage_4: values?.skUmessage_4,
            skUmessage_5: values?.skUmessage_5,

            // skuDetails:values?.skuDetails
            facilityId: isRowData?.facilityId.toString(),
            // facilityCategoryId:isRowData?.diagnosticCategory
          };
          const resp = dispatch(addServiceCreationAction(temp));
          resp.then((res) => {
            isLoadingAction(true, dispatch);
            if (res?.data?.status === true) {
              getSnackbarSuccess("success", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
              handleClose("update");
            } else {
              getSnackbarSuccess("error", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
            }
          });
        }}
        validationSchema={YUPValidationsServiceCreation}
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit, setFieldValue } =
            props;
          return (
            <form
              className="form-admin"
              style={{ overflowX: "hidden" }}
              onSubmit={handleSubmit}
            >
              <div className="modal-body addusermodalbox">
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">
                      Facility Type
                      <MandatoryStar />
                    </label>
                    <select
                      name="facilityId"
                      className="form-select form-select-admin"
                      value={values?.facilityId}
                      onChange={(e) => {
                        setFieldValue("facilityId", e.target.value);
                      }}
                    >
                      <option value="">Select Facility Type</option>
                      <option value={isRowData?.facilityId}>
                        {isRowData?.diagnosticCategory}
                      </option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.facilityId}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">
                      Facility Category
                      <MandatoryStar />
                    </label>
                    <select
                      name="facilityCategoryId"
                      className="form-select form-select-admin"
                      value={values?.facilityCategoryId}
                      onChange={handleChange}
                    >
                      <option value="">Select Test Type</option>
                      <option
                        value={
                          isAddServiceCreation?.rowData === null
                            ? 0
                            : data?.facilityCategoryId
                        }
                      >
                        {isRowData?.diagnosticCategory}
                      </option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.facilityCategoryId}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">
                      SKU Name
                      <MandatoryStar />
                    </label>
                    <input
                      name="testName"
                      type="text"
                      placeholder="SKU Name"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.testName}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">{errors?.testName}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">
                      APP Display Name
                      <MandatoryStar />
                    </label>
                    <input
                      name="displayName"
                      type="text"
                      placeholder="APP Display Name"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.displayName}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.displayName}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Package Tagging</label>
                    <select
                      name="packageTaggingId"
                      className="form-select form-select-admin"
                      value={values?.packageTaggingId}
                      onChange={handleChange}
                    >
                      <option value="">Select Package Tagging</option>
                      {TestPackageReducer?.getPackageTagListNetworkDetails?.map(
                        (ele, index) => {
                          return (
                            <option key={index} value={ele?.packageTaggingId}>
                              {ele?.packageTaggingName}
                            </option>
                          );
                        }
                      )}
                    </select>
                    <div className="errorInputMessage">
                      {errors?.packageTaggingId}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">SKU Type</label>
                    <select
                      name="testTypeId"
                      className="form-select form-select-admin"
                      value={values?.testTypeId}
                      onChange={handleChange}
                    >
                      <option value="">Select SKU Type</option>
                      {TestPackageReducer?.getTestTypeDetails?.map(
                        (ele, index) => {
                          return (
                            <option key={index} value={ele?.testTypeId}>
                              {ele?.displayName}
                            </option>
                          );
                        }
                      )}
                    </select>
                    <div className="errorInputMessage">
                      {errors?.testTypeId}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Fasting</label>
                    <select
                      name="isFastingRequired"
                      className="form-select form-select-admin"
                      value={values?.isFastingRequired}
                      onChange={(e) => {
                        setFieldValue(
                          "isFastingRequired",
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                            ? false
                            : e.target.value
                        );
                      }}
                    >
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.isFastingRequired}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Home Visit</label>
                    <select
                      name="isHomeVisitAllowed"
                      className="form-select form-select-admin"
                      value={values?.isHomeVisitAllowed}
                      onChange={(e) => {
                        setFieldValue(
                          "isHomeVisitAllowed",
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                            ? false
                            : e.target.value
                        );
                        setFieldValue("hvChargesId", "");
                      }}
                    >
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.isHomeVisitAllowed}
                    </div>
                  </div>
                  {values?.isHomeVisitAllowed && (
                    <div className="col-lg-4 col-md-4">
                      <label className="col-form-label">HV Charges</label>
                      <select
                        name="hvChargesId"
                        className="form-select form-select-admin"
                        value={values?.hvChargesId}
                        onChange={handleChange}
                      >
                        <option value="">Select HV Charges</option>
                        {TestPackageReducer?.getHVChargesForDetails?.map(
                          (ele, index) => {
                            return (
                              <option key={index} value={ele?.hvChargesId}>
                                {ele?.displayName}
                              </option>
                            );
                          }
                        )}
                      </select>
                      <div className="errorInputMessage">
                        {errors?.hvChargesId}
                      </div>
                    </div>
                  )}
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">MER Attach</label>
                    <select
                      name="isMERAttachmentRequired"
                      className="form-select form-select-admin"
                      value={values?.isMERAttachmentRequired}
                      onChange={(e) => {
                        setFieldValue(
                          "isMERAttachmentRequired",
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                            ? false
                            : e.target.value
                        );
                      }}
                    >
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.isMERAttachmentRequired}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">
                      Disabled For Pregnancy
                    </label>
                    <select
                      name="isDisabledForPregnancy"
                      className="form-select form-select-admin"
                      value={values?.isDisabledForPregnancy}
                      onChange={(e) => {
                        setFieldValue(
                          "isDisabledForPregnancy",
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                            ? false
                            : e.target.value
                        );
                      }}
                    >
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.isDisabledForPregnancy}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Gender</label>
                    <select
                      name="gender"
                      className="form-select form-select-admin"
                      value={values?.gender}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="B">Both</option>
                    </select>
                    <div className="errorInputMessage">{errors?.gender}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Report by</label>
                    <select
                      name="finalReporting"
                      className="form-select form-select-admin"
                      value={values?.finalReporting}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Next Day">Next Day</option>
                      <option value="Same Day">Same Day</option>
                      <option value="1 Day(s)*">1 Day(s)*</option>
                      <option value="2 Day(s)*">2 Day(s)*</option>
                      <option value="3 Day(s)*">3 Day(s)*</option>
                      <option value="4 Day(s)*">4 Day(s)*</option>
                      <option value="5 Day(s)*">5 Day(s)*</option>
                      <option value="6 Day(s)*">6 Day(s)*</option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.finalReporting}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Profile</label>
                    <select
                      name="isProfile"
                      className="form-select form-select-admin"
                      value={values?.isProfile}
                      onChange={(e) => {
                        setFieldValue(
                          "isProfile",
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                            ? false
                            : e.target.value
                        );
                      }}
                    >
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                    <div className="errorInputMessage">{errors?.isProfile}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Preparation</label>
                    <Select
                      className="basic-multi-select background_select-color"
                      style={{ width: "100%" }}
                      classNamePrefix="select"
                      placeholder="Select..."
                      name="colors"
                      value={
                        values?.preparationForCheckup
                          ? {
                              value: values?.preparationForCheckup,
                              label: values?.preparationForCheckup,
                            }
                          : null
                      }
                      options={TestPackageCreationReducer?.getPreparationForCheckup?.map(
                        (ele) => {
                          return {
                            value: ele?.preparationForCheckup,
                            label: ele?.preparationForCheckup,
                          };
                        }
                      )}
                      onChange={(e) => {
                        if (e?.value === "Create New +") {
                          setIsCreatingNew(true);
                        } else {
                          setFieldValue("preparationForCheckup", e?.value);
                        }
                      }}
                    />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Also Known As</label>
                    <input
                      name="synonyms"
                      type="text"
                      placeholder="Also Known As"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.synonyms}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">{errors?.synonyms}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Description</label>
                    <input
                      name="description"
                      type="text"
                      placeholder="Description"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.description}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.description}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Minimum Age</label>
                    <input
                      type="number"
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "-" || e.key === "+") {
                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                        }
                      }}
                      name="minAge"
                      placeholder="Minimum Age"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.minAge}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">{errors?.minAge}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label className="col-form-label">Maximum Age</label>
                    <input
                      type="number"
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "-" || e.key === "+") {
                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                        }
                      }}
                      name="maxAge"
                      placeholder="Minimum Age"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.maxAge}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">{errors?.maxAge}</div>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <label htmlFor=" Role" className="col-form-label">
                      SKU Search Tag
                    </label>
                    <Select
                      className="basic-multi-select background_select"
                      classNamePrefix="select"
                      placeholder="Search SKU Tag"
                      name="colors"
                      isMulti
                      closeMenuOnSelect={false}
                      options={TestPackageReducer?.getTagListNetworkDetails?.map(
                        (ele) => {
                          return {
                            value: ele?.tagName,
                            label: ele?.tagName,
                          };
                        }
                      )}
                      onChange={(e) => {
                        setFieldValue(
                          "tags",
                          e?.map((ele) => ele.value)?.toString()
                        );
                      }}
                      value={getSkuSearchTagValues(
                        TestPackageReducer?.getTagListNetworkDetails,
                        values?.tags
                      )}
                    />
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <label htmlFor=" Role" className="col-form-label">
                      SKU Details
                    </label>
                    <textarea
                      name="skuDetails"
                      value={values?.skuDetails}
                      onChange={handleChange}
                      placeholder="SKU Details"
                      className="form-control form-select-admin inputbgavanish  font-medium"
                    ></textarea>
                  </div>
                </div>
                <div className="col-12 mt-2 ms-3">
                <div>
                  <label className="col-form-label">SKU Feature</label>
                </div>
                  <ul>
                    <li style={{ listStyleType: "square" }}>
                      <div className="d-flex gap-2 mb-2">
                        <div className="col-10">
                          <input
                            name="skUmessage_1"
                            type="text"
                            placeholder="SKU Message"
                            value={values?.skUmessage_1}
                            onChange={handleChange}
                            // required
                            className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                          />
                          
                        </div>
                      </div>
                    </li>
                    <li style={{ listStyleType: "square" }}>
                      <div className="d-flex gap-2 mb-2">
                        <div className="col-10">
                          <input
                            name="skUmessage_2"
                            type="text"
                            placeholder="SKU Message"
                            value={values?.skUmessage_2}
                            onChange={handleChange}
                            className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                          />
                        </div>
                      </div>
                    </li>
                    <li style={{ listStyleType: "square" }}>
                      <div className="d-flex gap-2 mb-2">
                        <div className="col-10">
                          <input
                            name="skUmessage_3"
                            type="text"
                            placeholder="SKU Message"
                            value={values?.skUmessage_3}
                            onChange={handleChange}
                            className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                          />
                          
                        </div>
                      </div>
                    </li>
                    <li style={{ listStyleType: "square" }}>
                      <div className="d-flex gap-2 mb-2">
                        <div className="col-10">
                          <input
                            name="skUmessage_4"
                            type="text"
                            placeholder="SKU Message"
                            value={values?.skUmessage_4}
                            onChange={handleChange}
                            className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                          />
                          
                        </div>
                      </div>
                    </li>
                    <li style={{ listStyleType: "square" }}>
                      <div className="d-flex gap-2 mb-2">
                        <div className="col-10">
                          <input
                            name="skUmessage_5"
                            type="text"
                            placeholder="SKU Message"
                            value={values?.skUmessage_5}
                            onChange={handleChange}
                            className="form-control form-select-admin inputbgavanish serviceicon mb-2"
                          />
                          
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="modal-footer modal-footer-admin accept-reject-btns  accept-reject-btns-admin bottom-0  mt-4">
                <div>
                  {isAddServiceCreation?.rowData !== null && (
                    <div className="text-footer">
                      Activate For
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          dispatch(
                            activeInactiveTestCreationAction({
                              Target: "Portal",
                              isActive: e.target.checked,
                              productFacilityId:
                                isAddServiceCreation?.rowData
                                  ?.productFacilityId,
                            })
                          );
                          setFieldValue("isActiveForPPHC", e.target.checked);
                        }}
                        checked={values?.isActiveForPPHC}
                      />
                      IBU
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          dispatch(
                            activeInactiveTestCreationAction({
                              Target: "Product",
                              isActive: e.target.checked,
                              productFacilityId:
                                isAddServiceCreation?.rowData
                                  ?.productFacilityId,
                            })
                          );
                          setFieldValue("isActiveForProduct", e.target.checked);
                        }}
                        checked={values?.isActiveForProduct}
                      />
                      CBU
                    </div>
                  )}
                </div>
                <div>
                  <button type="submit" className="savedetails">
                    {isAddServiceCreation?.rowData === null ? "Save" : "Update"}
                  </button>
                </div>
              </div>
              <Modal
                isOpen={isCreatingNew}
                className="modal-confirmation-popup"
                overlayClassName="overlay-confirmation-popup network-z-index"
                ariaHideApp={false}
              >
                <div
                  className="modal-body modal-body-active-popup popup-text"
                  style={{ paddingBottom: "0px" }}
                >
                  <textarea
                    className="preparation-textarea"
                    placeholder="Enter preparation for checkup here..."
                    onChange={(e) => trimInputHandler(e, setCreateNewText)}
                  />
                </div>
                <div
                  className="modal-footer modal-footer-active-popup"
                  style={{ marginTop: "0px" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      getDispatch(
                        GET_PREPARATION_FOR_CHECKUP,
                        [
                          ...TestPackageCreationReducer?.getPreparationForCheckup,
                          { preparationForCheckup: createNewText },
                        ],
                        dispatch
                      );
                      setFieldValue("preparationForCheckup", createNewText);
                      setCreateNewText(null);
                      setIsCreatingNew(false);
                    }}
                    style={{ width: "90px" }}
                    disabled={
                      createNewText?.length === 0 || createNewText === null
                    }
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-logout-no"
                    onClick={() => {
                      setCreateNewText(null);
                      setIsCreatingNew(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </Modal>
            </form>
          );
        }}
      </Formik>
    </>
  );
};
